
            const data = {"name":"edit","data":{"viewBox":"0 0 60 60","data":"<path pid=\"0\" d=\"M48.83 1A10.18 10.18 0 0156 18.36L20.15 54.24a2.64 2.64 0 01-1.18.68l-14.61 4A2.67 2.67 0 011.09 57a2.77 2.77 0 010-1.4L5.08 41a2.64 2.64 0 01.68-1.18L41.64 4a10.09 10.09 0 017.19-3zM16.89 50l35.38-35.39a4.86 4.86 0 10-6.81-6.94l-.06.07L10 43.11l-2.56 9.45z\"/>","originalColors":[],"stopColors":[]}}
        
                module.exports = data
                